import { Accordion, Container, Section } from "@vcn/ui";
import { useContent } from "../content";

export function Faq() {
  const { faq } = useContent();

  return (
    /*
     * Das FAQ-Band ist im Entwurf ein transluzentes Panel (Element 630/549)
     * mit deutlich kräftigerer Schattenkante oben und unten
     * (Element 629/631 bzw. 547/548, je 81 von 1920 Einheiten hoch).
     */
    <Section
      id="faq"
      className="relative scroll-mt-20 bg-[var(--brand-faq-bg)]"
    >
      <span
        aria-hidden="true"
        className="pointer-events-none absolute inset-x-0 top-0 h-[4.22vw] max-h-20 min-h-8 bg-linear-to-b from-[var(--brand-faq-edge)] to-transparent"
      />
      <span
        aria-hidden="true"
        className="pointer-events-none absolute inset-x-0 bottom-0 h-[4.22vw] max-h-20 min-h-8 bg-linear-to-t from-[var(--brand-faq-edge)] to-transparent"
      />

      <Container className="relative">
        <h2 className="text-3xl font-bold text-white sm:text-4xl">{faq.title}</h2>
        <Accordion items={faq.items} className="mt-10" />
      </Container>
    </Section>
  );
}
